/*
 *
 * Copyright (c) Vaisala Oyj. All rights reserved.
 *
 */

import { matchPath, useLocation } from 'react-router-dom';

import { AppRoute } from '../../Routes';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

export function usePageTitle(routes: Array<AppRoute>) {
  const { pathname } = useLocation();
  const { t } = useTranslation();

  const pageDisplayName = useMemo(() => {
    const match = routes.find(({ path }) => {
      return matchPath(path as string, pathname);
    });

    if (match && match.name) {
      return t(match.name);
    }

    return t('Dual Lidar App');
  }, [pathname, t, routes]);

  return pageDisplayName;
}
